import { Checkbox, Container, DropDown, InputFieldWithIcon } from "../../utils/CustomComponents";
import { ReactComponent as Email } from "../../img/Section/Email.svg";
import { ReactComponent as Key } from "../../img/Section/Key.svg";
import { useEffect, useRef, useState } from "react";
import gsap, { Expo } from "gsap";
import { FiEdit3, HiLocationMarker } from "react-icons/all";
import { countries, states } from "../../utils/Tools";
import { useHistory } from "react-router-dom";
function CreatAccComp({ view_controller, auth_wrapperRef, setController }) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [password, setPassword] = useState("");
    const [agreement, setagreement] = useState(false);
    const h2 = useRef();
    const input = useRef();
    const button = useRef();
    const note = useRef();

    const [State, setUserState] = useState([]);
    const [TimeLine, setTimeLine] = useState(null);

    const history = useHistory();
    useEffect(() => {
        const parent = auth_wrapperRef.current;
        const signInanim = gsap.timeline({ paused: true });
        signInanim.from([h2.current, ...input.current.children, button.current, note.current], {
            autoAlpha: 0,
            y: 100,
            stagger: { each: 0.125 },
            ease: Expo.easeOut,
            duration: 2,
        });
        signInanim.play();
        setTimeLine(signInanim);
        parent.style.height = (window.innerWidth < 500 ? 800 : 1000) + "px";
        return () => {
            parent.style.height = 100 + "vh";
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [view_controller, auth_wrapperRef]);
    useEffect(() => {
        country && setUserState(states[country]);
    }, [country]);

    function createAcc(e) {
        e.preventDefault();
        // create account here
        history.push("/dashboard");
    }
    return (
        <div className="sign_up">
            <Container>
                <form onSubmit={createAcc}>
                    <h2 ref={h2}>Create an account</h2>
                    <div ref={input} className="form_group">
                        <InputFieldWithIcon
                            placeholder="Company Name"
                            icon={<FiEdit3 fontSize={20} />}
                            padding={15}
                            name="sign_in_compamny_name"
                            setValue={setName}
                            type="text"
                            value={name}
                        />
                        <InputFieldWithIcon
                            placeholder="email"
                            icon={<Email fontSize={20} />}
                            padding={15}
                            name="sign_in_company_email"
                            setValue={setEmail}
                            type="email"
                            value={email}
                        />
                        <DropDown
                            timeout={400}
                            header="Select Country"
                            dropListArray={countries.map((c) => ({ render: c }))}
                            setOption={setCountry}
                            placeHolder="Country"
                            customClassNames={"page-box dropDown"}
                            icon={<HiLocationMarker fontSize={20} />}
                            initialOption={country}
                            index={2}
                        />
                        <DropDown
                            timeout={400}
                            header="Select State"
                            dropListArray={State.map((c) => ({ render: c }))}
                            setOption={setState}
                            placeHolder="State"
                            customClassNames={"page-box dropDown"}
                            icon={<HiLocationMarker fontSize={20} />}
                            initialOption={state}
                            disabled={State.length === 0}
                            errMsg="Please Select a Country!"
                            index={1}
                        />
                        <InputFieldWithIcon
                            placeholder="password"
                            icon={<Key fontSize={20} />}
                            padding={15}
                            name="sign_in_company_password"
                            setValue={setPassword}
                            type="password"
                            value={password}
                        />
                        <Checkbox
                            Checked={agreement}
                            exe={() => {
                                setagreement(!agreement);
                            }}
                            text="I agree to the Terms of Service"
                            name="agreement"
                            id="agreement"
                            type={"checkbox"}
                        />
                    </div>
                    <button type="submit" className="btn_pry" ref={button}>
                        sign in
                    </button>
                </form>
                <div className="note" ref={note}>
                    Already have an Account?{" "}
                    <span
                        onClick={() => {
                            TimeLine.timeScale(3);
                            TimeLine.reverse();
                            setTimeout(() => {
                                setController("sign_in");
                            }, 1000);
                        }}
                    >
                        Sign IN
                    </span>
                </div>
            </Container>
        </div>
    );
}

export default CreatAccComp;
